function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { removePrefixFromCompositionName } from "../queryUtils/prefixes";
/**
 * Removes the composed prefix from path properties in GraphQLErrors.
 * This is meant to be used in the outer layer of our system, where errors are notified
 * to ObservableData instances so that consumers can access data without internals.
 */ export default function sanitizeComposedErrors(errors) {
    if (errors === null) {
        return null;
    }
    const sanitizedGraphqlErrors = errors.graphQlErrors.map(removePrefixedAliasFromPath);
    return _object_spread_props(_object_spread({}, errors), {
        graphQlErrors: sanitizedGraphqlErrors
    });
}
function removePrefixedAliasFromPath(graphQlError) {
    if (typeof graphQlError.path === 'undefined' || graphQlError.path === null) {
        return graphQlError;
    }
    const [topLevelFieldAlias, ...restPath] = graphQlError.path;
    const updatedPath = typeof topLevelFieldAlias === 'string' ? [
        removePrefixFromCompositionName(topLevelFieldAlias),
        ...restPath
    ] : graphQlError.path;
    return {
        message: graphQlError.message,
        path: updatedPath,
        extensions: graphQlError.extensions
    };
}

//# sourceMappingURL=sanitizeComposedErrors.js.map